import { plainDate } from "@redotech/rpc/ext";
import * as z from "zod/v4";
import {
  forecastFrequency,
  GetSkuSalesForecastOutput,
} from "./get-sku-sales-forecast";

export const getSkuSalesForecastBatch = {
  name: "getSkuSalesForecastBatch" as const,
  input: z.object({
    skus: z.array(z.string()),
    startDate: plainDate(),
    endDate: plainDate(),
    frequency: z.enum(forecastFrequency).optional().default("month"),
  }),
  output: z.object({
    forecasts: z.array(GetSkuSalesForecastOutput),
  }),
};
